// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ScrollableComponent_scrollContainer__nZmhd","hiddenScrollbar":"ScrollableComponent_hiddenScrollbar__qsFMy"};